import { reduxForm } from 'redux-form'
import at from 'lodash/at'

import { goBack } from 'react-router-redux'

import { assignServicing } from '../../actions/servicings'
import { fetchTechniciansAllocatedToWorkOrder } from '../../actions/technicians'

import AssignServicing from '../../components/servicings/assign-servicing'

const fields = [
  'technicianId'
]

function mapStateToProps (state, ownProps) {
  const servicing = state.servicings[ownProps.params.areaId]
  const technicians = at(state.users, state.technicians || [])

  return {
    modalTitle: 'Assign Area',
    initialValues: {
      technicianId: servicing.assignee
    },
    technicians
  }
}

function mapDispatchToProps (dispatch, ownProps) {
  dispatch(fetchTechniciansAllocatedToWorkOrder(ownProps.params.workOrderId))

  return {
    onSubmit (data) {
      dispatch(assignServicing(ownProps.params.areaId, data.technicianId))
        .then(() => dispatch(goBack()))
    },

    handleClose () {
      dispatch(goBack())
    }
  }
}

export default reduxForm(
  {
    fields,
    form: 'assignServicing'
  },
  mapStateToProps,
  mapDispatchToProps
)(AssignServicing)



// WEBPACK FOOTER //
// ./src/containers/servicings/assign-servicing-container.js